import React from "react";
import ReactDOM from "react-dom";

const el = document.createElement("div");

const Portal = ({ children }) => {
    const [root, setRoot] = React.useState();

    React.useEffect(() => {
        const tempRoot = document.getElementById("demo-portal-id");
        setRoot(tempRoot);
        tempRoot.appendChild(el);
        return () => {
            if (root) root.removeChild(el);
        };
    }, []);

    return ReactDOM.createPortal(children, el);
};

export default Portal;
